export var SlideDirection = /*#__PURE__*/ function(SlideDirection) {
    SlideDirection["LEFT"] = "left";
    SlideDirection["RIGHT"] = "right";
    return SlideDirection;
}({});

//# sourceMappingURL=types.js.map